<script lang="ts">
	import { useQueryClient } from '@tanstack/svelte-query';
	import { setContext } from 'svelte';
	import type { Readable } from 'svelte/store';
	import { ShopMixpanelEvents } from '../../constants/mixpanel-events';
	import { ShopRoutes } from '../../constants/routes';
	import { createShopCartQuery } from '../../utils/createShopCartQuery/createShopCartQuery';
	import { Contexts } from '#lib/constants/contexts.js';
	import { CartPlatform } from '#lib/features/checkout/constants/cart-plaforms.js';
	import { createCartIconContext } from '#lib/features/checkout/utils/createCartIconContext/index.js';
	import type { CartItems } from '#lib/features/checkout/utils/createCartItemsStore/index.js';
	import { createCheckoutContext } from '#lib/features/checkout/utils/createCheckoutContext/index.js';
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();

	const queryClient = useQueryClient();

	setContext(
		Contexts.Checkout,
		createCheckoutContext({
			mixpanelEvents: ShopMixpanelEvents,
			cartEntryClasses: { line3: 'hidden' },
			key: 'shop',
			codeEnabled: true,
			showZeroPence: false,
			checkoutRoute: ShopRoutes.Checkout,
			homeRoute: GlobalRoutes.ShopHome,
			browseButtonRoute: GlobalRoutes.ShopHome,
			browseButtonLabel: 'Browse Shop',
			orderConfirmedRoute: ShopRoutes.OrderConfirmed,
			platform: CartPlatform.Shop,
			createCartItemsQuery: (
				cartItems: Readable<CartItems | undefined>,
				defaultLoading?: boolean
			) => createShopCartQuery(queryClient, cartItems, defaultLoading),
		})
	);

	setContext(
		Contexts.ShowCartCheckout,
		createCartIconContext({ showCartIcon: true })
	);
</script>

{@render children?.()}
